module.exports = __webpack_public_path__ + "static/media/download-qrcode.27e222a2.png";